import { useAuth0 } from "@auth0/auth0-react";
import classNames from "classnames";
import { useEffect, useMemo, useState } from "react";
import { Button, Card, CardBody, CardHeader } from "reactstrap";
import { BackendService } from "../service/backend-service";
import { useStoreDispatch, useStoreSelector } from "../store/hooks";
import { addProject, getProjects, setProjects } from "../store/store-core";
import { errorMessage } from "../util/error-utils";
import { StyledToast } from "../util/styled-toast";
import ProjectContainer from "./project-container";

function Projects() {
  const [loading, setLoading] = useState(false);

  let dispatch = useStoreDispatch();
  let projects = useStoreSelector(getProjects);

  let auth0 = useAuth0();
  const service = useMemo(() => {
    return new BackendService(auth0);
  }, [auth0]);

  useEffect(() => {
    setLoading(true);
    service.getProjects()
      .then(projects => dispatch(setProjects(projects)))
      .catch((ex: any) => StyledToast.error(errorMessage(ex)))
      .finally(() => setLoading(false));
  }, [service, dispatch]); 

  function addProjectClicked() {
    let minCurrently = Math.min(...projects.map(project => project.id)) - 1;
    let newId = Math.min(-1, minCurrently);

    dispatch(addProject({
      id: newId,
      name: '',
      favorite: false,
      active: true,
      editing: true,
      color: 'secondary'
    }));
  }

  return (
    <Card className='mt-3'>
      <CardHeader>
        <i className='fas fa-fw fa-business-time me-2' />
        Projects
        <Button color='primary' size='small' className='pt-0 pb-0 float-end' onClick={addProjectClicked}>
          <i className='fas fa-plus me-2' style={{fontSize: '90%'}} />
          Project
        </Button>
      </CardHeader>
      <CardBody className={classNames({
        'row row-cols-xs-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4': true,
        'pb-0': !loading
      })}>
        {
          loading ? 
          <div className="loading-spinner text-center w-100">
            <div className="spinner-border text-warning" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div> 
        : projects.map(project => <ProjectContainer key={project.id} project={project} />)
        }
      </CardBody>
    </Card>
  );
}

export default Projects;
